import React from 'react';
import PublicLayout from '../components/PublicLayout';

export default function SupportPage() {
    return (
        <PublicLayout>
            <section className="py-24 relative overflow-hidden">
                <div className="absolute top-0 right-0 w-96 h-96 bg-premium-gold/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2"></div>
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                    <h1 className="text-5xl md:text-7xl font-black text-white mb-12 tracking-tighter">
                        Help & <br />
                        <span className="premium-gradient-text">Support</span>
                    </h1>

                    <div className="prose prose-invert max-w-none space-y-12 text-gray-300 text-lg leading-relaxed font-light">
                        <section>
                            <h2 className="text-2xl font-bold text-white mb-6 uppercase tracking-widest border-b border-premium-gold/30 pb-2">Overview</h2>
                            <p>
                                Our refund and returns policy lasts 14 days. If 14 days have passed since your purchase date, we can’t offer you a full refund or exchange.
                            </p>
                            <p className="mt-4">
                                To be eligible for a return, your item must be <strong className="text-white">UNUSED, UNOPENED</strong> and in the same condition that you received it. It must also be in the <strong className="text-white">original</strong> packaging.
                            </p>
                            <p className="mt-4">
                                Perishable goods are not eligible for refund once the order is in transit or if the goods are made with specific customization(s).
                            </p>
                            <p className="mt-4 font-medium text-white italic">
                                Please do not send your purchase back to us without being given confirmation. We do NOT return used products for compatibility issues or for user error (ordered by accident).
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold text-white mb-6 uppercase tracking-widest border-b border-premium-gold/30 pb-2">Refunds</h2>
                            <p>
                                Once your return is received and inspected, we will send you an email on your ticket to notify you that we have received your returned item. We will also notify you of the approval or rejection of your refund.
                            </p>
                            <p className="mt-4">
                                If you are approved, then your refund will be processed, and a credit will automatically be applied to your credit card or original method of payment, within a certain amount of days.
                            </p>
                            <div className="mt-6 p-6 bg-premium-gold/10 border border-premium-gold/20 rounded-2xl">
                                <p className="text-premium-gold font-bold">Important Note:</p>
                                <p>There is a <strong className="text-white">restocking fee of up to 40%</strong> depending on circumstances, this is non-negotiable.</p>
                            </div>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold text-white mb-6 uppercase tracking-widest border-b border-premium-gold/30 pb-2">Late or missing refunds</h2>
                            <p>
                                If you haven’t received a refund yet, first check your bank account again. Then contact your credit card company, it may take some time before your refund is officially posted.
                            </p>
                            <p className="mt-4">
                                Next contact your bank. There is often some processing time before a refund is posted.
                            </p>
                            <p className="mt-4">
                                If you’ve done all of this and you still have not received your refund yet, please contact us at <span className="text-premium-gold font-bold">support@odaz.app</span>.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold text-white mb-6 uppercase tracking-widest border-b border-premium-gold/30 pb-2">Exchanges and repairs</h2>
                            <p>
                                We only replace items if they are defective or damaged within 14 days. Compatibility issues will not be replaced, we are unable to swap one product with another.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold text-white mb-6 uppercase tracking-widest border-b border-premium-gold/30 pb-2">Shipping Returns</h2>
                            <p>
                                To return your product, firstly contact us at <span className="text-premium-gold font-bold">support@odaz.app</span> with your return or refund request. We will then provide a shipping address.
                            </p>
                            <ul className="list-disc pl-6 space-y-4 mt-4">
                                <li>You will be responsible for paying for your own shipping costs for returning your item.</li>
                                <li>Shipping costs are <strong className="text-white">non-refundable</strong>.</li>
                                <li>If you receive a refund, the cost of return shipping will be deducted from your refund.</li>
                            </ul>
                        </section>

                        <section className="mt-20 p-8 bg-gradient-to-br from-premium-gold/20 to-transparent border border-premium-gold/30 rounded-3xl text-center">
                            <h3 className="text-3xl font-black text-white mb-4 tracking-tighter">Need Help?</h3>
                            <p className="text-xl text-gray-300 mb-8">Contact us for any questions related to refunds and returns.</p>
                            <a href="mailto:support@odaz.app" className="inline-block px-12 py-4 bg-premium-gold text-black font-bold rounded-full hover:bg-white transition-all transform hover:scale-105 active:scale-95">
                                support@odaz.app
                            </a>
                        </section>
                    </div>
                </div>
            </section>
        </PublicLayout>
    );
}
